const memoryCache = new Map();

export const getScrollPosition = async (key) => {
  if (!key) return null;
  if (memoryCache.has(key)) {
    return memoryCache.get(key);
  }
  return null;
};

export const setScrollPosition = async (key, value) => {
  if (!key || !Number.isFinite(value)) return;
  memoryCache.set(key, value);
};

export const primeScrollPosition = (key, value) => {
  if (!key || !Number.isFinite(value)) return;
  memoryCache.set(key, value);
};
